import { withViewModel } from '../../../../../../infrastructure/components/with-view-model';
import { PodiumFormPresentation } from './podium-form.presentation';
import { PodiumFormViewModel } from './podium-form.viewmodel';

export type PodiumFormProps = {
    meetingId: number;
};

export const PodiumForm = withViewModel(PodiumFormPresentation, async (props: PodiumFormProps) => {
    const vm = new PodiumFormViewModel(props.meetingId);
    await vm.initFormVM();

    return vm;
});
